function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14.393 20a.447.447 0 01-.312-.13l-4.972-4.843H.469c-.26 0-.469-.229-.469-.512V.512C0 .23.21 0 .469 0H19.53c.26 0 .469.23.469.512v14.003c0 .283-.21.512-.469.512H14.91l-.047 4.468c-.003.28-.212.505-.469.505zM5 4.372a1 1 0 00-1 1v.185a1 1 0 001 1h10a1 1 0 001-1v-.185a1 1 0 00-1-1H5zm0 4.371a1 1 0 00-1 1v.186a1 1 0 001 1h4a1 1 0 001-1v-.186a1 1 0 00-1-1H5z"
});

function SvgNews(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgNews;